import React, {useEffect, useState} from "react";
import { useForm, Controller } from "react-hook-form";
import MobileHeader from "../../reusable/mobileHeader";
import Style from "../tickets.module.scss";
import LabelWithHR from "../../common/label/labelWithHR";
import Button from "../../common/button/button";
import { useTranslation } from "react-i18next";
import {CountryCode} from "../../reducers/ticket";
import { useContext } from "react";
import { TicketDetailsContext } from '../../components/TicketDetailsContext';
export function TicketsMobile({
  enterReferenceAndLicensePlate,
  setTicket,
  ticket,
  error,
  setError,
  shouldDisable,
  version,
}) {
  const { handleSubmit, control, formState : { errors }} = useForm(
    {
      mode: "onTouched",
      reValidateMode: "onChange",
      defaultValues: {
        reference: ticket.number,
        licensePlate: ticket.licensePlate,
      },
    }
  );
  const { t } = useTranslation();

  // Detect market based on hostname
  const { market } = useContext(TicketDetailsContext);

  return (
    <div className={Style.mainContainerMobile}>
      <MobileHeader logoHeader />
      <div className={Style.headingContainer}>
        <div className={Style.hairline}></div>
        <div className={Style.headingContainer__title}>
          <span className={Style.headingLabelDesktopPart1}>
            {t("Tickets.Desktop-Heading text part1").toString()}
          </span>
          <span className={Style.headingLabelDesktopPart2}>
            {t("Tickets.Desktop-Heading text part2").toString()}
          </span>
        </div>
      </div>
      <div className={Style.formMobile}>
        <p className={Style.formMobile__paragraphStyle}>
          {t("Tickets.Fill the fields below", { context: market }).toString()}
          <br />
          <span dangerouslySetInnerHTML={{ __html: t("Tickets.dataProtectionText") }} />
        </p>
        <form
          onSubmit={handleSubmit((data) => {
            const normalizedLicensePlate = ticket.licensePlate
              .toUpperCase()
              .replace(/[^A-Z0-9ÄÖÜß]/gi, "");
            enterReferenceAndLicensePlate({
              ...data,
              licensePlate: normalizedLicensePlate,
            });
            setTicket({ ...ticket, licensePlate: normalizedLicensePlate });
          })}
        >
          <LabelWithHR label={t("Tickets.Reference")} />
          <Controller
            name="reference"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type={"number"}
                placeholder="123456789"
                className={Style.input}
                name="reference"
                value={ticket.number}
                onChange={(e) => {
                  if (e.target.value.includes(" ")) {
                    return;
                  }

                  setTicket({ ...ticket, number: e.target.value });
                }}
              />
            )}
          />

          <LabelWithHR label={t("Tickets.License plate", { context: market })} />
          <Controller
            name="licensePlate"
            defaultValue=""
            control={control}
            render={({field}) => (
              <input
                type={"text"}
                placeholder={t("Tickets.License plate placeholder", { context: market })}
                className={Style.input}
                name="licensePlate"
                style={{
                  textTransform: "uppercase",
                }}
                value={ticket.licensePlate}
                onChange={(e) => {
                  field.onChange(e.target.value.toUpperCase())
                  setError("")
                  setTicket({ ...ticket, licensePlate: e.target.value });
                }}
                onBlur={field.onBlur}
              />
            )}
          />

          {error && (
            <div
              className={Style.errorMessage}
              onClick={() => {
                setError("");
              }}
            >
              {error}
            </div>
          )}
          <Button
            text={t("Tickets.Further")}
            disabled={shouldDisable()}
            classNameWrapper={Style.buttonMobile}
          />
        </form>
      </div>
      <div className={Style.versionBox}>VERSION:{version}</div>
    </div>
  );
}
